var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter,"after-enter":_vm.reset,"before-leave":_vm.beforeLeave,"leave":_vm.leave,"after-leave":_vm.reset}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }